import React from 'react';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const EmptyListDescription = ({ value }) => {
  return (
    <Text
      value={value}
      color={'primaryGray'}
      variant={'h6'}
    />
  );
};

EmptyListDescription.defaultProps = {
};

EmptyListDescription.propTypes = {
  value: PropTypes.string.isRequired,
};

export default EmptyListDescription;
